<template>
  <div>
    <h1>Admin</h1>

    <v-container>
      <v-row class="mb-6">
        <v-col>
          <h2 v-if="uninvitedUsers.length > 0">Inactive Users</h2>
          <base-list
            :showAdd="false"
            :showDelete="false"
            :listItems="uninvitedUsers"
            :link="setLink"
            listId="js-inactive-users"
          />
          <h2 v-if="mentors.length > 0">Mentors</h2>
          <base-list
            :showAdd="false"
            :showDelete="false"
            :listItems="mentors"
            :link="setLink"
            listId="js-mentors"
          />
        </v-col>
        <v-col>
          <v-sheet>
            <h2>create new user</h2>
            <v-form ref="form">
              <!-- first_name and email required for new user creation -->
              <v-text-field
                id="js-first-name-input"
                label="First Name"
                v-model="firstName"
                :rules="firstNameRules"
              ></v-text-field>
              <v-text-field
                id="js-last-name-input"
                label="Last Name"
                v-model="lastName"
              ></v-text-field>
              <v-text-field
                id="js-email-input"
                label="Email"
                v-model="email"
                :rules="emailRules"
              ></v-text-field>
              <v-text-field
                id="js-phone-number-input"
                label="Phone Number"
                v-model="phoneNumber"
              ></v-text-field>

              <v-radio-group v-model="userType" row>
                <v-radio
                  id="js-user-type-president"
                  label="President"
                  :value="1"
                ></v-radio>
                <v-radio
                  id="js-user-type-manager"
                  label="Manager/Mentor"
                  :value="2"
                ></v-radio>
                <v-radio
                  id="js-user-type-member"
                  label="Member/Mentee"
                  :value="4"
                ></v-radio>
              </v-radio-group>

              <v-btn
                id="js-add-button"
                class="default-action-btn"
                @click="save()"
                small
              >
                Create User
              </v-btn>
            </v-form>
          </v-sheet>
        </v-col>
      </v-row>
      <v-row class="mb-6">
        <v-col>
          <h2>Families</h2>
          <base-list
            :showAdd="false"
            :showDelete="false"
            :listItems="families"
            listId="js-families"
          />
        </v-col>
        <v-col>
          <v-sheet>
            <h2>create new family</h2>
            <v-form ref="formFamily">
              <v-text-field
                id="js-family-name-input"
                label="Family Name"
                v-model="familyName"
                :rules="familyNameRules"
              ></v-text-field>
              <v-btn
                id="js-add-family-button"
                class="default-action-btn"
                @click="addFamily()"
                small
              >
                Create Family
              </v-btn>
            </v-form>
          </v-sheet>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import titleMixin from "@/mixins/titleMixin"
import { UsersAPI, FamiliesAPI } from "@/lib/api"
import BaseList from "@/components/BaseList"
import User from "@/lib/user"

export default {
  components: { BaseList },
  mixins: [titleMixin],
  data: function() {
    return {
      title: "President User Admin",
      lastName: "",
      firstName: "",
      email: "",
      userType: 4,
      phoneNumber: "",
      uninvitedUsers: [],
      families: [],
      familyName: "",
      mentors: [],
      firstNameRules: [v => !!v || "First name is required"],
      familyNameRules: [v => !!v || "Family name is required"],
      emailRules: [
        v => !!v || "Email is required",
        v => /.+@.+/.test(v) || "Email must be valid"
      ]
    }
  },
  methods: {
    validateUser: function() {
      return this.$refs.form.validate()
    },
    validateFamily: function() {
      return this.$refs.formFamily.validate()
    },
    save: function() {
      if (this.validateUser()) {
        UsersAPI.create(
          this.firstName,
          this.lastName,
          this.email,
          this.userType,
          this.phoneNumber
        ).then(
          response => {
            this.$refs.form.reset()
            this.getUninvited()
          },
          error => {
            console.log(error.response)
          }
        )
      }
    },
    addFamily: function() {
      if (this.validateFamily) {
        FamiliesAPI.create({ name: this.familyName }).then(
          response => {
            this.$refs.formFamily.reset()
            this.getFamilies()
          },
          error => {
            console.log(error.response)
          }
        )
      }
    },
    getUninvited: function() {
      UsersAPI.list({ encrypted_password: "", disabled: false }).then(
        response => {
          this.uninvitedUsers = response.map(el => {
            return {
              id: el.id,
              name: `${el.first_name} ${el.last_name}`,
              avatar: el.avatar
            }
          })
        }
      )
    },
    getMentors: function() {
      UsersAPI.list({ user_type: 2, disabled: false }).then(response => {
        this.mentors = response.map(el => {
          return {
            id: el.id,
            name: `${el.first_name} ${el.last_name}`,
            avatar: el.avatar
          }
        })
      })
    },
    setLink(el) {
      return {
        name: "userDetailsView",
        params: { id: el.id }
      }
    },
    getFamilies: function() {
      FamiliesAPI.list().then(response => {
        this.families = response
      })
    }
  },
  created() {
    if (!User.isPresident()) {
      this.$router.push("/")
    }
  },
  mounted() {
    this.getUninvited()
    this.getFamilies()
    this.getMentors()
  }
}
</script>

<style lang="scss" scoped>
@import "../../scss/variables";
@import "../../scss/buttons";
</style>
